(() => {
  const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','advent_exp','advent_arm','advent_ad_id'];
  const query = new URLSearchParams(location.search);
  let saved = new URLSearchParams();
  try { saved = new URLSearchParams(sessionStorage.getItem('advent-v2-utm') || ''); } catch {}
  // A new paid click replaces the previous campaign, while internal links retain it.
  const params = query.has('utm_campaign') ? new URLSearchParams() : saved;
  for (const key of keys) if (query.has(key)) params.set(key,query.get(key).slice(0,240));
  const test = 'de-advent-destination-20261011';
  if (params.get('advent_exp') === test && window.ADVENT_MARKET?.country === 'DE') {
    let arm = params.get('advent_arm');
    if (!['lander','pdp'].includes(arm)) {
      try { arm = sessionStorage.getItem(test); } catch {}
      if (!['lander','pdp'].includes(arm)) arm = crypto.getRandomValues(new Uint32Array(1))[0] < 2147483648 ? 'lander' : 'pdp';
      params.set('advent_arm',arm);
    }
    try { sessionStorage.setItem(test,arm); } catch {}
    // Both destinations use the same existing component; no redirect or second ad is needed.
    if (window.ADVENT_START_ROUTE === 'landing' && arm === 'pdp') window.ADVENT_START_ROUTE = 'gold';
    query.set('advent_arm',arm);
    history.replaceState(history.state,'',location.pathname+'?'+query.toString()+location.hash);
  }
  try { sessionStorage.setItem('advent-v2-utm',params.toString()); } catch {}
  window.AdventAttribution = {
    params,
    properties: () => Object.fromEntries(keys.filter(key => params.has(key)).map(key => [key.startsWith('advent_')?key:'advent_'+key,params.get(key)]))
  };
})();
